import Button, { ButtonProps } from './Button';
import Spinner from './Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { styled, ThemeColors } from 'styled-components';

export type ActionButtonVariant = 'primary' | 'secondary' | 'outline';

type ActionButtonProps = {
    label: string;
    onClick: (e: React.MouseEvent<HTMLButtonElement>, id?: number) => void;
    disabled?: boolean;
    isLoading?: boolean;
    icon?: IconDefinition;
    bgColor?: keyof ThemeColors;
    color?: keyof ThemeColors;
    title?: string;
    height?: number;
    fullWidth?: boolean;
    className?: string;
    main?: boolean;
    rounded?: boolean;
    onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
} & Omit<ButtonProps, 'main' | 'bgColor' | 'border'>;

const ActionButton: React.FC<ActionButtonProps> = ({
    label,
    onClick,
    disabled = false,
    isLoading = false,
    icon,
    title,
    height = 35,
    fullWidth = false,
    bgColor,
    color,
    className,
    main,
    rounded = true,
    onKeyDown,
    ...rest
}) => {
    return (
        <StyledButton
            flex
            height={height}
            disabled={disabled || isLoading}
            $disabled={disabled || isLoading}
            rounded={rounded}
            onClick={onClick}
            bgColor={bgColor}
            color={color}
            title={title}
            fullwidth={fullWidth}
            className={className}
            main={main}
            onKeyDown={onKeyDown}
            {...rest}
        >
            {isLoading ? <Spinner color="main" /> : icon && <FontAwesomeIcon icon={icon} />}
            {label}
        </StyledButton>
    );
};

export default ActionButton;

const StyledButton = styled(Button)<{ border?: boolean; $disabled?: boolean }>`
    ${({ border, theme }) => border && `border: 1px solid ${theme.colors.borderLight};`}
    ${({ $disabled }) => $disabled && `cursor: text;`}
    display: flex;
    font-family: inherit;
`;
